// @flow

export default {
  wrappedComponentWrapper: {
    position: 'relative',
  },
};
